<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h4>
          Evolução do Usuário: <b>{{ usuario.nome_completo }}</b>
        </h4>

        <button
          class="btn btn-default"
          data-style="zoom-in"
          type="button"
          @click="$parent.evolucoes = false"
        >
          <i class="mdi mdi-arrow-left" />
        </button>
      </div>
    </div>

    <modulo-comentario
      label="Descrição da Evolução"
      textoBotao="Cadastrar
    Evolução"
      module="Scfv"
      model="ScfvGruposVinculo"
      :id="$route.params.vinculo"
    />
  </div>
</template>
<script>
export default {
  props: ["usuario"],
  name: "Evolucao",
};
</script>
